<!-- =========================================================================================
  File Name: StoreData.vue
  Description: Store data
  ----------------------------------------------------------------------------------------
  Item Name: C4 - Store data for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->


<template>
  <!--    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">-->
  <vs-popup fullscreen :active.sync="isSpecialActiveLocal" :title="title">
    <form-wizard
      ref="couponWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true">
      <tab-content v-for="(option, index) in data.specialData" :key="option.id" :title="option.name" icon="feather icon-package" class="mb-5">
        <template>
          <div class="flex justify-between mb-2">
            <div class="vx-col w-4/5">
              <h6>Mínimo {{ option.min }} - Máximo {{ option.max }} / <b>Seleccionados: {{ option.qtySelected }}</b></h6><br/>
            </div>
            <vs-spacer/>
            <div class="vx-col w-1/5">
              <vs-button
                class="ml-auto flex"
                icon-pack="feather" icon="icon-arrow-right-circle"
                color="success"
                v-if="option.qtySelected >= option.min && option.qtySelected <= option.max"
                @click.prevent="$refs.couponWizard.nextTab()">
                SIGUIENTE
              </vs-button>
            </div>
          </div>
          <div class="items-grid-view vx-row match-height">
            <div class="vx-col lg:w-1/5 sm:w-1/5 w-full" v-for="item in option.options" :key="item.code">
              <item-grid-view :item="item">
                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                  <div class="flex flex-wrap">
                    <vs-chip color="danger" style="position: absolute; top: 10px; left: 10px;" v-if="getQuantityCoupon(item)"><b>{{ item.qtySelected }}</b></vs-chip>
                    <!--                  <vs-avatar color="danger" icon-pack="feather" size="50px" style="position: absolute; top: 5px;" @text="item.qtySelected"/>-->
                  </div>
                  <div class="flex flex-wrap">

                    <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                    <div class="item-view-primary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white cursor-pointer" @click="addQty(item, index)">
                      <feather-icon icon="ShoppingPlusCircle" svgClasses="h-4 w-4"/>

                      <span class="text-sm font-semibold ml-2">AGREGAR</span>
                    </div>

                    <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                    <div class="item-view-secondary-action-btn bg-danger p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                         @click="subtractQty(item, index)">
                      <feather-icon icon="ShoppingMinusCircle" svgClasses="h-4 w-4"/>

                      <span class="text-sm font-semibold ml-2">ELIMINAR</span>
                    </div>
                  </div>
                </template>
              </item-grid-view>

            </div>
          </div>
        </template>

      </tab-content>
      <tab-content title="Revisión" icon="feather icon-check-square">
        <template>
          <div class="vx-row">
            <div class="vx-col w-full">
              <h4>Productos seleccionados</h4><br/>
              <vs-list>
                <span  v-for="option in data.specialData" :key="option.id">
                  <vs-list-header icon-pack="feather" icon="icon-plus-square" :title="option.name"/>
                  <span v-for="item in option.options" :key="item.id">
                    <vs-list-item icon-pack="feather" icon="icon-check" :title="optionTitle(item)" v-if="item.qtySelected > 0"/>
                  </span>
                </span>
              </vs-list>
<!--              <ul>-->
<!--                <li v-for="option in data.specialData" :key="option.id">-->
<!--                  <h6>{{ option.name }}</h6>-->
<!--                  <ul>-->
<!--                    <li v-for="item in option.options" :key="item.id">-->
<!--                      <span v-if="item.qtySelected > 0">{{ item.qtySelected }} {{ item.name }}</span>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                  <br>-->
<!--                </li>-->
<!--              </ul>-->
            </div>
          </div>
          <div class="flex justify-start">
              <vs-button
                icon-pack="feather" icon="icon-arrow-left-circle"
                color="danger"
                class="mr-2"
                @click="$refs.couponWizard.reset()"
              >
                CAMBIAR
              </vs-button>
              &nbsp;&nbsp;
              <vs-button
                icon-pack="feather" icon="icon-arrow-right-circle"
                color="success"
                @click="acceptCoupon"
              >
                ACEPTAR
              </vs-button>
          </div>
        </template>

      </tab-content>
    </form-wizard>
  </vs-popup>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  const ItemGridView = () => import('./ItemGridView.vue');

  export default {
    props: {
      id: {
        code: '',
        name: '',
        specialOptions: 0,
        specialData: [],
        couponOptions: []
      },
      isSpecialActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        data: {
          code: '',
          name: '',
          specialOptions: 0,
          specialData: []
        },
        // couponOptions: [],
        acceptMobilePayment: false,
        selectedState: null,
        selectedCity: null,
        loaded: false,
        disableEditID: false,
        title: '',
        name: '',
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    components: {
      VuePerfectScrollbar,
      FormWizard,
      TabContent,
      ItemGridView
    },
    computed: {
      isSpecialActiveLocal: {
        get() {
          return this.isSpecialActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar');
          }
        }
      }
    },
    watch: {
      isSpecialActiveLocal: function () {
        if (this.isSpecialActiveLocal) {
          this.initValues();
          this.title = this.id.name;
          this.data = this.id;
          for (var i = 0; i < this.data.specialData.length; i++) {
            this.data.specialData[i].qtySelected = 0;
            this.data.specialData[i].title = this.data.specialData[i].name + ' - Mínimo ' + parseInt(this.data.specialData[i].min) + ' - Máximo ' + parseInt(this.data.specialData[i].max)
            for (var j = 0; j < this.data.specialData[i].options.length; j++) {
              this.data.specialData[i].options[j].qtySelected = 0;
            }
          }
        }
      }
    },
    methods: {
      initValues() {
        this.data = {
          code: '',
          name: '',
          specialOptions: 0,
          specialData: []
        };
        this.$refs.couponWizard.reset();
      },
      getQuantityCoupon(item) {
        var hasQuantity = false;
        if (item.hasOwnProperty('qtySelected')) {
          if (item.qtySelected > 0) {
            hasQuantity = true;
          }
        }
        return hasQuantity;
      },
      addQty(item, index) {
        if (this.data.specialData[index].qtySelected < this.data.specialData[index].max) {
          item.qtySelected++;
          this.data.specialData[index].qtySelected++;
          this.$forceUpdate();
        }
      },
      subtractQty(item, index) {
        if (item.qtySelected > 0) {
          item.qtySelected--;
          this.data.specialData[index].qtySelected--;
          this.$forceUpdate();
        }
      },
      optionTitle(option) {
        return `${option.qtySelected} ${option.name}`
      },
      acceptCoupon() {
        this.id.couponOptions = [];
        var products;
        for (var i = 0; i < this.data.specialData.length; i++) {
          products = [];
          for (var j = 0; j < this.data.specialData[i].options.length; j++) {
            if (this.data.specialData[i].options[j].qtySelected > 0) {
              products.push(this.data.specialData[i].options[j]);
            }
          }
          this.id.couponOptions.push({
            name: this.data.specialData[i].name,
            products: products
          });
        }
        this.isSpecialActiveLocal = false;
        this.$emit('addCouponCart');
      }

    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background {
      z-index: 52010;
    }

    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
